import { connect, MapStateToProps } from 'react-redux';
import { Props } from './StudioTableMobile';
import { AppState } from '../../types/store';
import {
  getActiveSection,
  getHasResults,
  getIsProductsSection,
} from '../../selectors/studio';
import { getHasSubfolders } from '../../selectors/stash';

export type StateProps = Pick<
  Props,
  'activeSection' | 'hasDeviations' | 'hasSubfolders' | 'isProductsSection'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  activeSection: getActiveSection(state),
  hasDeviations: getHasResults(state),
  hasSubfolders: getHasSubfolders(state),
  isProductsSection: getIsProductsSection(state),
});

export default connect(mapStateToProps);
